"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.getIsHost = exports.getPingTime = exports.getMultiName = exports.isUsEx = exports.isUs = exports.getMultiId = exports.getIsSingleplayer = void 0;
var diveMultiplayerCursors_sidecar_1 = require("@dive/indicators/diveMultiplayerCursors-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageWebsockets_extensions_sidecar_1 = require("@voyage/multi/voyageWebsockets_extensions-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
function getIsSingleplayer() {
    return websockets_sidecar_1.websockets.getIsSingleplayer();
}
exports.getIsSingleplayer = getIsSingleplayer;
function getMultiId() {
    return websockets_sidecar_1.websockets.getMultiId();
}
exports.getMultiId = getMultiId;
function isUs(multiId) {
    return multiId === websockets_sidecar_1.websockets.getMultiId();
}
exports.isUs = isUs;
function isUsEx(multiId) {
    var _isUs = isUs(multiId);
    var from = diveMultiplayerCursors_sidecar_1.diveMultiplayerCursors.findByMultiIdSafe(multiId);
    if (!_isUs && !from) {
        console.warn('isUsEx', 'no from', multiId);
    }
    return { isUs: _isUs, from: from };
}
exports.isUsEx = isUsEx;
function getMultiName() {
    return websockets_sidecar_1.websockets.getMultiName();
}
exports.getMultiName = getMultiName;
function getPingTime() {
    return websockets_sidecar_1.websockets.getPingTime();
}
exports.getPingTime = getPingTime;
function getIsHost() {
    return websockets_sidecar_1.websockets.getIsHost();
}
exports.getIsHost = getIsHost;
function create() {
    websockets_sidecar_1.websockets.create(voyageWebsockets_extensions_sidecar_1.voyageWebsockets_extensions, voyageTestParams_sidecar_1.voyageTestParams.version);
    websockets_sidecar_1.websockets.tryConnect();
}
exports.create = create;
